import type { WaterlyAppStateCreator } from "./waterlyAppStateCreator.type";

export enum OnlineStatus {
  online = "online",
  offline = "offline",
}

type OnlineStatusState = {
  onlineStatus: OnlineStatus;
};

type OnlineStatusActions = {
  setOnlineStatus: (onlineStatus: OnlineStatus, reason: string) => void;
};

const onlineStatusFromBrowser = () => (window.navigator.onLine ? OnlineStatus.online : OnlineStatus.offline);

const initialState: OnlineStatusState = {
  onlineStatus: onlineStatusFromBrowser(),
};

export const createOnlineStatusSlice: WaterlyAppStateCreator<OnlineStatusActions, OnlineStatusState> = (
  set,
) => ({
  ...initialState,
  setOnlineStatus: (onlineStatus, reason) => {
    // eslint-disable-next-line no-console
    console.debug(`Received ${onlineStatus} event: ${reason}`);

    set({ onlineStatus }, undefined, "onlineStatus:setOnlineStatus");
  },
});
